import { sessionState } from '../auth/session-state';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReCaptcha2Component } from 'ngx-captcha';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../auth/auth.service';
import * as myGlobalFunc from '../global.function';
import * as myGlobalsfunc from '../global.function';
import { ConfirmPasswordValidator } from './confirm_password.validator'; // password  & confirm password matching
import { RegistrationService } from './registration.service';

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss'],
    standalone: false
})
export class RegistrationComponent implements AfterViewInit {
  @ViewChild('firstName') firstName: ElementRef;
  @ViewChild('captchaElem') capcta: ReCaptcha2Component;
  registerForm: UntypedFormGroup;
  items: UntypedFormArray;
  public pageContent: any = [];
  public displayTC: Boolean = false;
  public submitted = false;
  public cities1: any;
  public professions: any;
  public counter: [1, 2, 3];
  public selectedTabs: any[] = [1,2,3,4];

  public list: any = [];
  public list_cm: any = [];
  public list_ot: any = [];
  public list_physio: any = [];
  public list_neuropsy: any = [];
  public list_neuro: any = [];
  public list_cp: any = [];
  public list_slt: any = [];
  public list_others: any = [];
  public showOthers: any = false;
  public formSubmitted: any = false;
  public message: any;
  public showFailMessage: any = false;
  public showmessage: any;
  public disableSubmit: any = true;
  public submitedForm: any = false;
  public transData: any = '';
  public currency: any = [];
  constructor(
    private spinner: NgxSpinnerService,
    private registrationService: RegistrationService,
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {
    this.spinner.show();
    /* Set the Default Language */
    this.translate.setDefaultLang('en');

    /* Send to the Dashboard if the user is logged in */
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['']);
    }

    this.translate.get('registration').subscribe(text => {
      this.transData = text;
      /* Charge Name And their value */
      this.list.push(
        {
          charge_name: this.transData.cm_assistant,
          time: '50.00',
          travel: '25.00',
          mileage: '00.50'
        },
        {
          charge_name: this.transData.admin,
          time: '40.00',
          travel: '20.00',
          mileage: '00.50'
        }
      );
      this.list_cm.push(
        {
          charge_name: this.transData.cm,
          time: '60.00',
          travel: '30.00',
          mileage: '00.50'
        },
        {
          charge_name: this.transData.cm_assistant,
          time: '50.00',
          travel: '25.00',
          mileage: '00.50'
        },
        {
          charge_name: this.transData.admin,
          time: '40.00',
          travel: '20.00',
          mileage: '00.50'
        }
      );
      this.list_ot.push(
        {
          charge_name: this.transData.ot,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        },
        {
          charge_name: this.transData.ot_assistant,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        },
        {
          charge_name: this.transData.admin,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        }
      );
      this.list_physio.push(
        {
          charge_name: this.transData.physio,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        },
        {
          charge_name: this.transData.physio_assistant,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        },
        {
          charge_name: this.transData.admin,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        }
      );
      this.list_neuropsy.push(
        {
          charge_name: this.transData.npsych,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        },
        {
          charge_name: this.transData.npsych_assistant,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        },
        {
          charge_name: this.transData.admin,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        }
      );
      this.list_neuro.push(
        {
          charge_name: this.transData.therapy,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        },
        {
          charge_name: this.transData.therapy_assistant,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        },
        {
          charge_name: this.transData.admin,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        }
      );
      this.list_cp.push(
        {
          charge_name: this.transData.sessionWeekday,
          time: '60.00',
          travel: '00.00',
          mileage: '00.00'
        },
        {
          charge_name: this.transData.sessionWeekend,
          time: '70.00',
          travel: '00.00',
          mileage: '00.00'
        }
      );
      this.list_slt.push(
        {
          charge_name: this.transData.SLT,
          time: '70.00',
          travel: '00.00',
          mileage: '00.00'
        },
        // {
        //   charge_name: this.transData.SLT_Assistant,
        //   time: '35.00',
        //   travel: '00.00',
        //   mileage: '00.00'
        // },
        // {
        //   charge_name: this.transData.admin,
        //   time: '40.00',
        //   travel: '20.00',
        //   mileage: '00.50'
        // }
      );
      this.list_others.push(
        {
          charge_name: this.transData.therapy,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        },
        {
          charge_name: this.transData.therapy_assistant,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        },
        {
          charge_name: this.transData.admin,
          time: '60.00',
          travel: '50.00',
          mileage: '00.50'
        }
      );
      this.professions = [
        { 
          label:this.transData.case_management,
          name: this.transData.case_management,
          code: this.transData.cm,
          primaryName: this.transData.case_manager,
          primaryAbbr: this.transData.cm,
          secondaryname: this.transData.second_CM,
          secondaryAbbr: this.transData.second_CM_Abbr,
          tertiaryName: this.transData.cm_assistant,
          tertiaryAbbr: this.transData.CM_Ast,
          charge_name: {
            name_1: this.transData.cm,
            name_2: this.transData.cm_assistant,
            name_3: this.transData.admin
          }
        },
        {
          label: this.transData.counselling_psychotherapy_label,
          name: this.transData.counselling_psychotherapy,
          code: this.transData.cp,
          primaryName: this.transData.cp_therapist,
          primaryAbbr: this.transData.cp_therapist_abbr,
          charge_name: {
            name_1: this.transData.sessionWeekday,
            name_2: this.transData.sessionWeekend
          }
        },
        { 
          label: this.transData.occupational_therapy,
          name: this.transData.occupational_therapy,
          code: this.transData.ot,
          primaryName: this.transData.occupational_therapist,
          primaryAbbr: this.transData.ot,
          secondaryname: this.transData.second_OT,
          secondaryAbbr: this.transData.second_OT_Abbr,
          tertiaryName: this.transData.ot_assistant,
          tertiaryAbbr: this.transData.oT_ast,
          charge_name: {
            name_1: this.transData.ot,
            name_2: this.transData.ot_assistant,
            name_3: this.transData.admin
          }
        },
        { 
          label: this.transData.Neuropsychology,
          name: this.transData.Neuropsychology,
          code: this.transData.Npsych,
          primaryName: this.transData.Neuropsychologist,
          primaryAbbr: this.transData.npSych,
          secondaryname: this.transData.Second_neuropsych,
          secondaryAbbr: this.transData.second_PSY,
          tertiaryName: this.transData.admin_assistant,
          tertiaryAbbr: this.transData.admin,
          charge_name: {
            name_1: this.transData.Npsych,
            name_2: this.transData.npsych_assistant,
            name_3: this.transData.admin
          }
        },
        { 
          label: this.transData.Neurotherapy,
          name: this.transData.Neurotherapy,
          code: this.transData.thp,
          primaryName: this.transData.lead_therapist,
          primaryAbbr: this.transData.first_TH,
          secondaryname: this.transData.assistant_case_manager,
          secondaryAbbr: this.transData.second_TH,
          tertiaryName: this.transData.admin_assistant,
          tertiaryAbbr: this.transData.admin,
          charge_name: {
            name_1: this.transData.therapy,
            name_2: this.transData.therapy_assistant,
            name_3: this.transData.admin
          }
        },
        {
          label: this.transData.Physiotherapy,
          name: this.transData.Physiotherapy,
          code: this.transData.Physio,
          primaryName: this.transData.Physiotherapist,
          primaryAbbr: this.transData.pt,
          secondaryname: this.transData.second_physio,
          secondaryAbbr: this.transData.secondnd_PT,
          tertiaryName: this.transData.physio_assistant,
          tertiaryAbbr: this.transData.PT_Ast,
          charge_name: {
            name_1: this.transData.Physio,
            name_2: this.transData.physio_assistant,
            name_3: this.transData.admin
          }
        },
        {
          label: this.transData.SpeechAndLanguage_label,
          name: this.transData.SpeechAndLanguage,
          code: this.transData.sal,
          primaryName: this.transData.slt,
          primaryAbbr: this.transData.slt,
          charge_name: {
            name_1: this.transData.SLT,
            name_2: this.transData.SLT_Assistant,
            name_3: this.transData.admin
          }
        },
        { 
          label: this.transData.others,
          name: this.transData.others,
          code: this.transData.oth,
          primaryName: this.transData.lead_clinician,
          primaryAbbr: this.transData.first_CL,
          secondaryname: this.transData.Second_Clinician,
          secondaryAbbr: this.transData.second_CL,
          tertiaryName: this.transData.admin_assistant,
          tertiaryAbbr: this.transData.admin,
          charge_name: {
            name_1: this.transData.therapy,
            name_2: this.transData.therapy_assistant,
            name_3: this.transData.admin
          }
        }
      ];
      this.registrationService.getCountry().subscribe(data => {
        this.spinner.hide();
        this.createForm();
        this.addDefaultChargeRate(this.list);
        if (data.status === 1) {
          this.cities1 = data.data;
          if (this.cities1 && this.cities1.length > 0) {
            let ukIndex = this.cities1.map(e => {return e.name}).indexOf('United Kingdom');
            this.registerForm.get('country').setValue(this.cities1[ukIndex]);
          }
        } else {
          this.showFailMessage = true;
          this.message = data.message;
          window.scroll(0, 0);
        }
      });
    });
  }

  closeDialog() {
    this.displayTC = false;
  }

  get f() {
    return this.registerForm.controls;
  }

  handleReset() {
    this.reload();
  }

  setFormat(inputArray, field, index) {
    const formArray = this.registerForm.get(inputArray) as UntypedFormArray;
    const inputValue = formArray.at(index).get(field).value;
    const splitValue = (inputValue !== null
      ? inputValue.toString()
      : '0.00'
    ).split('.');
    if (splitValue[0].length === 0) {
      splitValue[0] = '0';
    }
    splitValue[0] = splitValue[0].slice(0, 3);
    splitValue[1] = splitValue[1] !== undefined ? splitValue[1] : '00';

    const formattedValue = Number(
      splitValue[0].toString() + '.' + splitValue[1].toString()
    ).toFixed(2);
    formArray
      .at(index)
      .get(field)
      .setValue(formattedValue);
  }

  restrictNumbers(e) {
    if (e.key === '-' || e.key === 'Enter') {
      e.preventDefault();
      return;
    }
  }

  OpenModal() {
    this.displayTC = true;
  }

  restrictSpecialChar(e: any) {
    const regex = '^[^<>\'"/;`%]*$';
    e.preventDefault();
    return;
  }

  createForm() {
    this.registerForm = this.formBuilder.group(
      {
        first_name: [
          '',
          [Validators.required, Validators.pattern('(.*[a-z0-9A-Z].*)')]
        ],
        last_name: [
          '',
          [Validators.required, Validators.pattern('(.*[a-z0-9A-Z].*)')]
        ],
        email_address: [
          '',
          [
            Validators.required,
            Validators.pattern(
              '^([a-zA-Z0-9_.-]+)@([a-zA-Z0-9_.-]+)\.([a-zA-Z.]{2,})$'
            )
          ]
        ],
        phone_number: [
          '',
          [
            Validators.required,
            Validators.min(0),
            Validators.pattern('(\\+? ?[0-9]+)*')
          ]
        ],
        password: [
          '',
          [
            Validators.required,
            Validators.pattern(
              '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])[\\w~@#$%^&*+=`|{}:;!.?\\"()\\[\\]-]{8,255}$'
            )
          ]
        ],
        confirm_password: ['', Validators.required],
        company_name: [
          '',
          [Validators.required, Validators.pattern('(.*[a-z0-9A-Z].*)')]
        ],
        address_line_1: [
          '',
          [Validators.required, Validators.pattern('(.*[a-z0-9A-Z].*)')]
        ],
        address_line_2: [''],
        address_line_3: [''],
        town: [
          '',
          [Validators.required, Validators.pattern('(.*[a-z0-9A-Z].*)')]
        ],
        county: ['', Validators.pattern('(^[a-z0-9A-Z ]+$)')],
        postcode: [
          '',
          [
            Validators.required,
            Validators.pattern(
              '^(([a-zA-Z0-9]+)|([a-zA-Z0-9]+( [a-zA-Z0-9]+)))$'
            )
          ]
        ],
        country: ['', Validators.required],
        acceptedCheck: [0],
        profession: ['', Validators.required],
        billingBasis: [1, Validators.required],
        other_profession: [''],
        show_other_profession: [0],
        items: this.formBuilder.array([]),
        currency: ['', Validators.required],
        recaptcha: ['', Validators.required]
      },
      {
        validator: ConfirmPasswordValidator.MatchPassword
      }
    );

    this.registrationService.getCurrency().subscribe(data => {
      if (data.status === 1) {
        this.currency = data.data;
        if (window.localStorage.getItem('terms_conditions_page')) {
          this.pageContent['terms_conditions_page'] = window.localStorage.getItem('terms_conditions_page');
          this.pageContent[`terms_conditions_page_updated`] = myGlobalFunc.convertDate(
            new Date(
              window.localStorage.getItem(`terms_conditions_page_updated`) + ' UTC'
            ),
            false
          );
        } else {
          this.pageContent['terms_conditions_page'] = '';
          this.pageContent[`terms_conditions_page_updated`] = '';
        }
        if (this.currency && this.currency.length > 0) {
          this.registerForm.get('currency').setValue(this.currency[0]);
        }
      } else {
        this.showFailMessage = true;
        this.message = data.message;
        window.scroll(0, 0);
      }
    });
  }

  // ngOnInit() {}

  public findInvalidControls() {
    const invalid: any = [];
    const controls = this.registerForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  reload(): void {
    this.capcta.resetCaptcha();
  }

  disablePaste(e) {
    e.preventDefault();
    return;
  }

  addDefaultChargeRate(list) {
    for (let i = 0; i < list.length; i++) {
      this.addItem(
        list[i].charge_name,
        list[i].time,
        list[i].travel,
        list[i].mileage
      );
    }
  }

  createItem(charge_var, time_var, travel_var, mileage_var): UntypedFormGroup {
    return this.formBuilder.group({
      charge_name: [charge_var, Validators.required],
      time: [time_var, Validators.required],
      travel: [travel_var, Validators.required],
      mileage: [mileage_var, Validators.required]
    });
  }

  addItem(charge_var, time_var, travel_var, mileage_var): void {
    this.items = this.registerForm.get('items') as UntypedFormArray;
    this.items.push(
      this.createItem(charge_var, time_var, travel_var, mileage_var)
    );
  }

  removeItem(index) {
    if (index === 0) {
      return;
    }
    this.items = this.registerForm.get('items') as UntypedFormArray;
    this.items.removeAt(index);
  }

  removeAllItem() {
    this.items = this.registerForm.get('items') as UntypedFormArray;
    while (0 !== this.items.length) {
      this.items.removeAt(0);
    }
  }

  // event handler function for custom servuce/ profession option
  professionChange(selected_value) {
    if (this.registerForm) {
      this.showOthers = false;
      this.registerForm.get('other_profession').setValidators([]);
      this.registerForm.get('other_profession').updateValueAndValidity();
      this.registerForm.patchValue({billingBasis: 1});
      this.removeAllItem();
      switch (selected_value.value.code) {
        case 'OT':
          // code...
          this.addDefaultChargeRate(this.list_ot);
          break;
        case 'CP':
          // code...
          this.registerForm.patchValue({billingBasis: 0});
          this.addDefaultChargeRate(this.list_cp);
          break;
        case 'Physio':
          // code...
          this.addDefaultChargeRate(this.list_physio);
          break;
        case 'SAL':
          // code...
          this.registerForm.patchValue({billingBasis: 0});
          this.addDefaultChargeRate(this.list_slt);
          break;
        case 'Npsych':
          // code...
          this.addDefaultChargeRate(this.list_neuropsy);
          break;
        case 'THP':
          // code...
          this.addDefaultChargeRate(this.list_neuro);
          break;
        case 'OTH':
          // code...
          this.addDefaultChargeRate(this.list_others);
          this.registerForm
            .get('other_profession')
            .setValidators([Validators.required]);
          this.registerForm.get('other_profession').updateValueAndValidity();
          this.showOthers = true;
          break;
        case 'CM':
          // code...
          this.addDefaultChargeRate(this.list_cm);
          break;

        default:
          // code...
          break;
      }
    }
  }

  cancel($event) {
    this.router.navigate(['/login']);
  }

  onSubmit() {
    this.submitted = true;
    this.disableSubmit = false;
    this.submitedForm = true;
    // return
    this.spinner.show('message');
    // stop here if form is invalid
    if (this.registerForm.invalid || this.f.acceptedCheck.value.length === 0) {
      this.message = 'invalid data';
      return;
    }
    this.formSubmitted = true;
    this.registrationService
      .saveSignup(this.registerForm.value)
      .subscribe(data => {
        this.submitted = false;
        this.spinner.hide('message');
        if (data.status === 1) {
          sessionState.setItem(
            'access_token',
            data.user.access_token
          );
          sessionState.setItem('expires_in', data.user.expires_in);
          sessionState.setItem('id_token', data.user.id_token);
          sessionState.setItem('user_id', data.user.user_id);
          this.disableSubmit = true;
          this.router.navigate(['']);
        } else if (data.status === 0) {
          this.message = data.message;
          this.showFailMessage = true;
          window.scroll(0, 0);
          this.reload();
        } else {
          this.showFailMessage = true;
          this.message = data.message;
          window.scroll(0, 0);
          this.reload();
        }
      });
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {
    window.scroll(0, 0);
    if (this.firstName) {
      this.firstName.nativeElement.focus();
    }
  }
}
